module.exports = __webpack_public_path__ + "img/1429425267.0fa1d804.jpg";